import store from '../store';
import { actions, setPreOrder, setErrors } from './reducer';
import * as contextHandlers from './contextHandlers';

const fetcher = async request => {
  const { data } = await request;

  if(data.redirect_url){
    window.location.replace(data.redirect_url)
  }

  if (data.errors) {
    store.dispatch(setErrors(data.errors));
  }

  store.dispatch(setPreOrder(data.pre_order));

  for (let context of data.context_list) {
    const { page_name, page_context } = context;

    const action = actions[`set${page_name}Context`];
    action && store.dispatch(action(page_context));

    const handler = contextHandlers[page_name];
    handler && handler(page_context);
  }

  return data;
};

export default fetcher;
